/**
 * @Author: Zero
 * @Date: 2025-05-14 15:20:07
 * @Explain: 联系人报表
 */
// type
import { CascaderSelectProps } from '@/components/tdesign/data.d';

export interface ContactReportState {
  /** 大区级联下拉项信息 */
  regionOptions: CascaderSelectProps['options'];
}

export type ModelType = {
  namespace: string;
  state: ContactReportState;
  reducers: {
    setRegionOptions: (
      state: ContactReportState,
      action: { payload: any },
    ) => any;
  };
};

const ContactReportModel: ModelType = {
  namespace: 'ContactReportModel',
  state: {
    // 联系人报表 - 大区级联下拉项信息
    regionOptions: [],
  },
  reducers: {
    // 设置 大区级联下拉项信息
    setRegionOptions(state, action) {
      const { regionOptions } = action.payload;
      return {
        ...state,
        regionOptions: regionOptions || [],
      };
    },
  },
};

export default ContactReportModel;
